import {
  FETCH_DELETE_DOCUMENTS_REQUEST,
  FETCH_DELETE_DOCUMENTS_SUCCESS,
  FETCH_DELETE_DOCUMENTS_FALUIRE,
} from './deleteDocumentsTypes'

const initialState = {
  loading: false,
  deleteDocumentsInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DELETE_DOCUMENTS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_DOCUMENTS_SUCCESS : return {
      ...state,
      deleteDocumentsInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_DOCUMENTS_FALUIRE : return {
      ...state,
      loading: false,
      deleteDocumentsInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
